import React, { useEffect, useState } from 'react'
import {
    onAuthStateChanged,
    getAuth,
} from 'firebase/auth';
import firebase_app from '../lib/firebaseConfig';

const auth = getAuth(firebase_app);

export const FirebaseAuthContext = React.createContext()



export default function FirebaseAuthProvider({ children }) {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);
    return (<FirebaseAuthContext.Provider value={{
        user,
        loading
    }}>{children}</FirebaseAuthContext.Provider>)
}